module.exports = [{
      plugin: require('/builds/warsteiner/warsteiner-headless/warsteiner-frontend/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/builds/warsteiner/warsteiner-headless/warsteiner-frontend/src/components/common/Layout/Layout.js"},
    },{
      plugin: require('/builds/warsteiner/warsteiner-headless/warsteiner-frontend/node_modules/gatsby-plugin-graphql-preview/gatsby-browser.js'),
      options: {"plugins":[],"fieldName":"craft","typeName":"Craft","url":"https://cms.warsteiner.de/api","headers":{"Authorization":"bearer 5_k5V_f4vGM5iePYTkeaFco2JIdIKUVgN6XnFjzNmuh0Qb1WYiXtC64tG4HpIiYs"},"refetchInterval":120},
    },{
      plugin: require('/builds/warsteiner/warsteiner-headless/warsteiner-frontend/node_modules/gatsby-plugin-emotion/gatsby-browser.js'),
      options: {"plugins":[],"autoLabel":true},
    },{
      plugin: require('/builds/warsteiner/warsteiner-headless/warsteiner-frontend/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
